export enum EventVariableLimit {
    MAX = 65535,
    MIN = 0,
}
